import MainMobile from './plugins/CORE/defs/mobile/main/main.ui';
import PluginCoreMobile from './plugins/CORE/defs/mobile';
import PluginClipsMobile from './plugins/CLIPS/defs/mobile';
import PluginBookmarkMobile from './plugins/BOOKMARK/defs/mobile';
import PluginShareMobile from './plugins/SHARE/defs/mobile';
import PluginVisMobile from './plugins/VIS/defs/mobile';
import { withOctopus } from '../../utils/octopus';
import withGalleryProvider from './context/with-gallery-provider';

const GalleryMobile = withGalleryProvider(
  withOctopus({ debugMode: false, componentName: 'Gallery' }, PluginCoreMobile, MainMobile),
);

export { GalleryMobile, PluginClipsMobile, PluginBookmarkMobile, PluginShareMobile, PluginVisMobile };
